<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M24 15.12l16 16H8l16-16m0-3.28a2.35 2.35 0 00-1.65.68L4.69 30.19a2.32 2.32 0 001.64 4h35.34a2.32 2.32 0 001.64-4L25.65 12.52a2.35 2.35 0 00-1.65-.68z"/></svg>